// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tbParticle } from "../../engine/tbParticle";
import { tgfFunctions } from "../../framework/tgfFunctions";
import { PhysicsSettings } from "../../settings/PhysicsSettings";
import { SoundManager } from "../../settings/SoundManager";
import { ParticleEffect } from "../ParticleEffect";
import { PhysicsObject } from "../PhysicsObject";
import { ReplayLogger } from "../ReplayLogger";
import { getContainerForLayer, Layer, physics } from "../SceneController";
import { SpineEffect } from "../SpineEffect";
import { playController } from "../gameController";
tgfFunctions.inherit(BirdObjectDefault, PhysicsObject);
export function BirdObjectDefault(def, uid, x, y, angle, container) {
    BirdObjectDefault.uber.constructor.call(this, def, uid, x, y, angle, container);
    var self = this;
    this.featherContact = false;
    this.canUsePower = true;
    this.body.SetActive(false);
    this.birdObject = this;
    this.needToActivateSpecialPower = false;
    var scale = (1 / PhysicsSettings.textureResolution);
    this.effectScale = scale; // * PhysicsSettings.extraTextureScale;
    this.soundStates = SoundManager.BIRD_STATE;
    this.isBird = true;
    this.stepsUntilCanBeInactive = 15;
    this.particle();
    this.spineInit();
    this.onFirstContact = function () {
        ReplayLogger.log("First Contact");
        self.impactEffect();
    };
}
BirdObjectDefault.prototype.isActive = function (damage) {
    if (!this.firstContact || this.stepsUntilCanBeInactive >= 0) {
        return true;
    }
    else {
        return BirdObjectDefault.uber.isActive.call(this, damage);
    }
};
BirdObjectDefault.prototype.applyDamage = function (damage) {
    BirdObjectDefault.uber.applyDamage.call(this, damage);
    if (this.firstContact && damage > 25) {
        var capDamage = Math.max(25, Math.min(damage, 75));
        new SpineEffect(this.x, this.y, this.definition.impact.spine, this.definition.impact.name, getContainerForLayer(Layer.smokePuff), (capDamage / 20) * 0.5);
    }
};
BirdObjectDefault.prototype.physicsStep = function () {
    "use strict";
    BirdObjectDefault.uber.physicsStep.call(this);
    if (this.firstContact) {
        this.stepsUntilCanBeInactive--;
    }
};
BirdObjectDefault.prototype.particle = function () {
    "use strict";
    this.featherParticle = new tbParticle(this.container, this.definition.featherParticle.particle, this.definition.featherParticle.images);
    this.featherParticle.setScale(this.effectScale + 0.02);
    this.featherParticle.setPosition(this.x, this.y);
    this.featherParticle.show();
};
BirdObjectDefault.prototype.spineInit = function () {
};
BirdObjectDefault.prototype.destroyEffect = function () {
    "use strict";
    new SpineEffect(this.x, this.y, this.definition.smokePuff.spine, this.definition.smokePuff.name, getContainerForLayer(Layer.smokePuff), 0.5);
    new ParticleEffect(this.x, this.y, {
        container: this.container,
        scale: 0.02,
        particle: this.definition.featherParticle.particle,
        images: this.definition.featherParticle.images
    });
};
BirdObjectDefault.prototype.launch = function (direction, force) {
    if (this.body) {
        this.body.SetActive(true);
        physics.setVelocity(this.body, direction.x * force, direction.y * force);
    }
    //when the bird is moving left, flip its animation vertically, so that it will be rendered correctly, instead of up-side-down.
    if (direction.x < 0) {
        this.image.flipVertically();
    }
    this.playSound(this.soundStates.RELEASE, this.definition.sounds);
};
//returns true if the power was activated
BirdObjectDefault.prototype.activateSpecialPower = function () {
    return false;
};
BirdObjectDefault.prototype.finalEffect = function () {
    "use strict";
    if (this.featherParticle) {
        this.featherParticle.destroy();
    }
    if (this.specialAbilityEffect) {
        this.container.removeChild(this.specialAbilityEffect);
        this.specialAbilityEffect.free();
        this.specialAbilityEffect = null;
    }
    this.playSound(this.soundStates.DEATH, this.definition.sounds);
    this.destroyEffect();
};
BirdObjectDefault.prototype.impactEffect = function () {
    "use strict";
    new SpineEffect(this.x, this.y, this.definition.smokePuff.spine, this.definition.smokePuff.name, getContainerForLayer(Layer.smokePuff), 0.5);
    this.playSound(this.soundStates.IMPACT, this.definition.sounds);
};
BirdObjectDefault.prototype.applyBirdSpeedBoost = function (force, oldHealth, velocityFactor) {
    if (force <= 0 || this.isDead()) {
        return;
    }
    var multiplier = (force - oldHealth) / (force);
    multiplier *= velocityFactor;
    if (multiplier > 1.0) {
        multiplier = 1.0;
    }
    physics.setVelocity(this.body, this.velocity.x * multiplier, this.velocity.y * multiplier);
    // console.log ("applyBirdSpeedBoost - " + multiplier);
};
BirdObjectDefault.prototype.speedUp = function (force) {
    var l = this.velocity.length();
    var raiseFactor = 1 + (force / l);
    var x = this.velocity.x * raiseFactor;
    var y = this.velocity.y * raiseFactor;
    physics.setVelocity(this.body, x, y);
};
BirdObjectDefault.prototype.destroy = function () {
    "use strict";
    BirdObjectDefault.uber.destroy.call(this);
    this.finalEffect();
    playController.sceneBuilder.cameraAnimationTimer = 0;
};
BirdObjectDefault.prototype.step = function (timePassed) {
    BirdObjectDefault.uber.step.call(this, timePassed);
    if (!this.featherContact && this.firstContact) {
        this.featherParticle.destroy();
        this.featherParticle = undefined;
        this.particle();
        this.featherContact = true;
    }
    if (this.featherParticle) {
        this.featherParticle.update(timePassed);
    }
};
